/**
 * Shipments whose stops are highlighted in the route list: the selected one, plus every
 * shipment cube will dispatch with it when it routed a whole assignment group.
 */
export function getHighlightedShipmentIds(
  selectedShipmentId: string | undefined,
  allShipmentIdsForGroupDispatch: string[] | null | undefined,
): string[] {
  const selectedShipmentIds = selectedShipmentId ? [selectedShipmentId] : [];
  const groupShipmentIds = allShipmentIdsForGroupDispatch ?? [];
  return Array.from(new Set([...selectedShipmentIds, ...groupShipmentIds]));
}
